<template>
  <span>
    <el-select ref="editor" v-if="visible" size="mini" v-model="value" filterable :clearable="clearable" autocomplete @blur="onBlur" @fucus="onFocus" @change="onChange" @clear="endEdit" @visible-change="onVisibleChange">
      <el-option v-for="item in list" :key="item[keyField]" :label="item[labelField]" :value="item[valueField]"></el-option>
    </el-select>
    <span v-else-if="$slots.content === undefined"> {{ displayValue }} </span> <slot v-else></slot>
  </span>
</template>

<script>
import find from 'lodash/find';
import { getValueAfterCheckEmpty, EMPTY_TEXT } from '@/utils/string';
import InputCellEditorMixin from './mixins/input-cell-editor';

// TODO: remote 검색일 경우 id가 아닌 name 기준으로 검색이 되어야하므로 문제 있음. 대응방안 마련 필요.
export default {
  name: 'WSelectEditor',
  mixins: [InputCellEditorMixin],
  props: {
    /**
     * 콤보박스 데이터
     */
    list: {
      type: Array,
      dafault: () => [],
    },
    /**
     * 콤보박스 키 필드
     * @type {Object}
     */
    keyField: {
      type: String,
      required: true,
    },
    /**
     * 콤보박스 라벨 필드
     * @type {Object}
     */
    labelField: {
      type: String,
      required: true,
    },
    /**
     * 콤보박스 값 필드
     */
    valueField: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      /**
       * 드롭다운 메뉴 오픈 여부
       */
      optionVisible: false,
      /**
       * 콤보박스 input field에 대한 blur 여부
       * @type {Boolean}
       */
      blur: false,
    };
  },
  computed: {
    /**
     * 콤보박스 데이터에서 value에 대한 label field의 값을 찾아 반환한다.
     * @author Ju
     */
    displayValue() {
      if (this.data && this.property) {
        let value = this.data[this.property];
        if (value) {
          const currentData = find(this.list, (item) => item[this.valueField] === value);
          value = currentData ? currentData[this.labelField] : value;
        }
        return getValueAfterCheckEmpty(value);
      }
      return EMPTY_TEXT;
    },
  },
  methods: {
    /**
     * change 이벤트 핸들러
     * @author Ju
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    onChange(val) {
      this.endEdit();
      console.debug('[cell on change]', val, this.value);
    },
    /**
     * focus 이벤트 핸들러
     * @author Ju
     */
    onFocus() {
      this.blur = false;
    },
    /**
     * blur 이벤트 핸들러
     * @author Ju
     */
    onBlur() {
      console.debug('[cell on blur]', this.value);
      // 콤보박스의 input field와 드롭다운 메뉴 모두 포커스를 잃은 경우에만 셀 편집 종료
      if (this.optionVisible) {
        this.blur = true;
      } else {
        this.endEdit();
      }
    },
    /**
     * visible-change 이벤트 핸들러
     * @author Ju
     */
    onVisibleChange(val) {
      console.debug('[cell on visible]', val);
      // 콤보박스의 input field와 드롭다운 메뉴 모두 포커스를 잃은 경우에만 셀 편집 종료
      this.optionVisible = val;
      if (this.blur && !val) {
        this.endEdit();
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/table/cell-editor/SelectEditor.vue